import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { deleteJob } from "../lib/deleteJob";
import { useWallet } from "../hooks/useWallet";

export const DeleteJobButton = ({ dispatch, onDeleted, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const { refresh } = useWallet() || {};

  const confirm = async (e) => {
    e?.stopPropagation(); e?.preventDefault();
    setBusy(true);
    try {
      const { refunded } = await deleteJob(dispatch);
      toast.success(refunded ? "Job deleted · Credit returned" : "Job deleted");
      refresh?.(); setTimeout(() => refresh?.(), 1500);
      setOpen(false); onDeleted?.(dispatch);
    } catch (err) { toast.error(err.message); }
    setBusy(false);
  };

  return (<>
    {compact ? (
      <button type="button" className="icon-btn text-[#FF7A7A]" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} aria-label="Delete job" data-testid={`delete-job-${dispatch.id}`}><Trash2 size={16} /></button>
    ) : (
      <button type="button" className="btn-secondary text-[#FF7A7A] flex items-center justify-center gap-2" onClick={() => setOpen(true)} data-testid="delete-job-button"><Trash2 size={16} /> Delete job</button>
    )}
    {open && (
      <div className="sheet-backdrop" onClick={(e) => { e.stopPropagation(); setOpen(false); }} data-testid="delete-confirm-backdrop">
        <div className="sheet" onClick={(e) => e.stopPropagation()} data-testid="delete-confirm">
          <p className="eyebrow">Delete</p>
          <h2 className="card-title">Delete this job?</h2>
          <p className="text-sm text-muted mt-2">The contractor link will stop working.{dispatch.status === "draft" ? " Your credit will be returned." : ""}</p>
          <div className="flex gap-3 mt-5">
            <button type="button" className="btn-secondary" onClick={(e) => { e.stopPropagation(); setOpen(false); }} data-testid="delete-cancel">Keep</button>
            <button type="button" className="btn-danger" onClick={confirm} disabled={busy} data-testid="delete-confirm-button">{busy ? "Deleting…" : "Delete"}</button>
          </div>
        </div>
      </div>
    )}
  </>);
};
